import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router'
import { Subject } from 'rxjs'
import { filter, takeUntil } from 'rxjs/operators'
import { ApplicationCreatorState } from '../../services/application-creator-state.service'

@Component({
  selector: 'application-creator',
  templateUrl: './application-creator-shell.component.html',
  styleUrls: ['./application-creator-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ApplicationCreatorShellComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>()

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private applicationCreatorState: ApplicationCreatorState
  ) {}

  ngOnInit() {
    // Get accountId from parent route params
    const accountId = this.route.parent?.snapshot.paramMap.get('accountId')
    if (accountId) {
      // Set account ID for state persistence
      this.applicationCreatorState.setAccountId(accountId)
    }

    // Listen for route changes to sync state
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.syncStateWithRoute()
      })
  }

  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete()
  }

  private syncStateWithRoute(): void {
    const url = this.router.url

    // Determine current page route relative to base
    let pageRoute = ''
    if (url.includes('/applications/new/resources')) {
      pageRoute = 'resources'
    } else if (url.includes('/applications/new/connect')) {
      pageRoute = 'connect'
    } else if (url.includes('/applications/new/templates')) {
      pageRoute = 'templates'
    } else if (url.includes('/applications/new/access-method')) {
      pageRoute = 'access-method'
    }

    // Update the state's current step
    this.applicationCreatorState.currentStep = pageRoute || 'details'
    this.applicationCreatorState.markDirty()
  }
}
